import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  message, Button, Card, Table, Spin, Tooltip, Divider,
} from 'antd'

import { CopyOutlined, EditOutlined } from '@ant-design/icons'

import { fetch } from '../../../utils/fetch'

import ModalRemark from './ModalRemark'

const { Column } = Table

const TempSo = ({ orderId, orderType }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(null)
  const [visibleRemark, setVisibleRemark] = useState(false)
  const [referenceData, setReferenceData] = useState(null)

  useEffect(
    () => {
      if (orderType) {
        fetch({
          url: `/order/${orderId}/item/${orderType}/SO_TEMP`,
        }).then((res) => {
          // console.log(res?.data?.data)
          setData(res?.data?.data)
          setIsLoading(false)
        })
      }
    }, [orderId, orderType])

  const numberWithCommas = (price) => {
    if (!isNaN(price)) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return '-'
  }

  const remerkComponent = (remarkValue, soNo) => {
    if (!soNo) {
      return <>-</>
    }
    if (remarkValue) {
      return (
        <>
          <>{remarkValue}</>
          <Divider type="vertical" />
          <EditOutlined
            onClick={() => {
              setReferenceData({
                referenceCode: soNo,
                remark: remarkValue,
              })
              setVisibleRemark(true)
            }}
          />
        </>
      )
    }
    return (
      <EditOutlined
        onClick={() => {
          setReferenceData({
            referenceCode: soNo,
            remark: null,
          })
          setVisibleRemark(true)
        }}
      />
    )
  }

  const onCancelModalRemark = () => {
    setVisibleRemark(false)
    setReferenceData(null)
  }

  const onSuccessRemark = () => {
    setVisibleRemark(false)
    setReferenceData(null)
    setIsLoading(true)
    if (orderType) {
      fetch({
        url: `/order/${orderId}/item/${orderType}/SO_TEMP`,
      }).then((res) => {
        // console.log(res?.data?.data)
        setData(res?.data?.data)
        setIsLoading(false)
      })
    } else {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <Card
          title="Temporary SO (Fiori)"
          type="inner"
        >
          <Table
            dataSource={data}
            size="small"
            bordered
            pagination={false}
            scroll={{ x: 1150, y: 300 }}
          >
            <Column ellipsis align="center" title="#" dataIndex="itmNumber" key="itmNumber" width={80} render={(value) => (value ? `${value}` : '-')} />
            <Column ellipsis align="left" title="Article No." dataIndex="articleNo" key="articleNo" width={100} render={(text) => text || '-'} />
            <Column ellipsis align="left" title="Article Desc" dataIndex="articleDescr" key="articleDescr" width={200} render={(text) => text || '-'} />
            <Column ellipsis align="right" title="Unit Price" dataIndex="itemUnitPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
            <Column ellipsis align="center" title="Qty" dataIndex="itemQty" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
            <Column ellipsis align="right" title="Net Price" dataIndex="itemNetPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
            <Column
              ellipsis
              align="left"
              title="Vendor"
              dataIndex="article"
              width={200}
              render={(value, row) => {
                const obj = {
                  children: <>{value?.vendorCode} {value?.vendorName}</> || '-',
                  props: {
                    rowSpan: 1,
                  },
                }
                if (value.articleType === 2) {
                  obj.props.rowSpan = row.span
                }
                return obj
              }}
            />
            <Column align="center" title="Ref No." dataIndex="soNo" key="soNo" width={120} render={(value, row) => ({ children: value || '-', props: { rowSpan: row.span } })} />
            <Column
              // ellipsis
              align="center"
              title="Remark"
              dataIndex="remark"
              key="remark"
              width={140}
              render={(value, row) => ({
                children: remerkComponent(value, row.soNo),
                props: { rowSpan: row.span },
              })}
            />
            <Column
              title="Action"
              dataIndex="soNo"
              key="soNo"
              fixed="right"
              align="center"
              width={100}
              render={(value, row) => ({
                children: (
                  <Tooltip placement="top" title="Copy Ref No.">
                    <CopyToClipboard text={value || ' '}>
                      <Button disabled={!value} icon={<CopyOutlined />} shape="circle" onClick={() => message.success('Copy to clipboard')} />
                    </CopyToClipboard>
                  </Tooltip>
                ),
                props: {
                  rowSpan: row.span,
                },
              }
              )}
            />
          </Table>
        </Card>
      </Spin>
      <ModalRemark
        visibleRemark={visibleRemark}
        onCancel={onCancelModalRemark}
        referenceData={referenceData}
        orderId={orderId}
        onSuccess={onSuccessRemark}
      />
    </>
  )
}

export default TempSo

TempSo.propTypes = {
  orderId: PropTypes.string.isRequired,
  orderType: PropTypes.string.isRequired,
}
